
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pos-hardware-partners/tvs",
      function () {
        return require("private-next-pages/pos-hardware-partners/tvs.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pos-hardware-partners/tvs"])
      });
    }
  